import { render, staticRenderFns } from "./ProgramadorSeleccioneTipos.vue?vue&type=template&id=2ca70d50&"
import script from "./ProgramadorSeleccioneTipos.vue?vue&type=script&lang=js&"
export * from "./ProgramadorSeleccioneTipos.vue?vue&type=script&lang=js&"
import style0 from "./ProgramadorSeleccioneTipos.vue?vue&type=style&index=0&id=2ca70d50&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports